import React, { useMemo } from 'react';

export default function AlertModal({ alert, onClose }) {
  const theme = useMemo(() => {
    const tipo = ((alert?.TipoAlerta || alert?.type || '') + '').toUpperCase().trim();
    if (tipo === 'AMARILLA') return { bg: '#fef9c3', border: '#f59e0b', text: '#92400e', title: 'Alerta Amarilla' };
    if (tipo === 'NARANJA') return { bg: '#ffedd5', border: '#f97316', text: '#9a3412', title: 'Alerta Naranja' };
    return { bg: '#fee2e2', border: '#ef4444', text: '#991b1b', title: tipo ? `Alerta ${tipo}` : 'Alerta' };
  }, [alert]);

  if (!alert) return null;

  const get = (...keys) => {
    for (const k of keys) {
      if (alert && k in alert && alert[k] !== undefined && alert[k] !== null && `${alert[k]}`.trim() !== '') return alert[k];
      const lk = (k || '').toString().toLowerCase();
      if (alert && lk in alert && alert[lk] !== undefined && alert[lk] !== null && `${alert[lk]}`.trim() !== '') return alert[lk];
    }
    return '';
  };

  const unidad = get('unidadConductor', 'unit', 'unidad');
  const nombre = get('nombreConductor', 'driverName', 'conductor');
  const placa = get('placaConductor', 'plate');
  const telefono = get('telefonoConductor', 'phone');

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.45)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2000,
      padding: 16
    }}>
      <div style={{
        width: '100%',
        maxWidth: 520,
        background: 'white',
        borderRadius: 12,
        overflow: 'hidden',
        boxShadow: '0 20px 25px -5px rgba(0,0,0,0.2)'
      }}>
        <div style={{
          padding: '14px 16px',
          background: theme.bg,
          borderBottom: `3px solid ${theme.border}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12
        }}>
          <div style={{ color: theme.text, fontWeight: 'bold', fontSize: 18 }}>
            {theme.title}
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'white',
              border: `1px solid ${theme.border}`,
              color: theme.text,
              borderRadius: 8,
              padding: '6px 10px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            Cerrar
          </button>
        </div>

        <div style={{ padding: 16 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '140px 1fr', gap: 10, fontSize: 14 }}>
            <div style={{ color: '#64748b', fontWeight: 'bold' }}>Unidad</div>
            <div style={{ color: '#0f172a' }}>{unidad || '—'}</div>
            <div style={{ color: '#64748b', fontWeight: 'bold' }}>Conductor</div>
            <div style={{ color: '#0f172a' }}>{nombre || '—'}</div>
            <div style={{ color: '#64748b', fontWeight: 'bold' }}>Placa</div>
            <div style={{ color: '#0f172a' }}>{placa || '—'}</div>
            <div style={{ color: '#64748b', fontWeight: 'bold' }}>Teléfono</div>
            <div style={{ color: '#0f172a' }}>{telefono || '—'}</div>
          </div>

          <div style={{ marginTop: 14, fontSize: 12, color: '#64748b' }}>
            La alerta se cerrará automáticamente y el documento se eliminará de Firestore.
          </div>
        </div>
      </div>
    </div>
  );
}

